import type { TableRowType } from 'components/editor/grid/reduxStore/table.types';
import { validCrmFieldInstanceEntries } from './crmFieldInstancesGuard';

// `template` values reach here from persisted crmFieldInstances (untyped storage, see
// crmFieldInstancesGuard.ts) and from unchecked casts over clipboard JSON — never assume
// it's a string. A non-string or empty-string input has no valid array identity, so it
// returns undefined rather than throwing or silently matching everything. (An empty string
// must be excluded explicitly: ''.slice(0, ''.lastIndexOf('.')) is '', not undefined, which
// would otherwise read as a valid — and always-conflicting — identity.)
export const crmArrayIdentity = (template: unknown): string | undefined =>
  typeof template === 'string' && template !== '' ? template.slice(0, template.lastIndexOf('.')) : undefined;

export function rowCrmArrayConflict(row: TableRowType | undefined, incomingTemplate: string | null | undefined): boolean {
  if (!row?.crmFieldInstances || !incomingTemplate) return false;
  const incomingArray = crmArrayIdentity(incomingTemplate);
  // No valid identity to conflict against — nothing to compare, so no conflict.
  if (incomingArray === undefined) return false;
  return validCrmFieldInstanceEntries(row).some(([, instances]) =>
    instances.some((instance) => {
      const instanceArray = crmArrayIdentity(instance?.template);
      // A non-string persisted template has no identity either — skip it, same as the
      // existing guard skips a malformed (non-array) crmFieldInstances value instead of
      // treating it as an automatic conflict.
      return instanceArray !== undefined && instanceArray !== incomingArray;
    })
  );
}
